import React, { useState, useEffect } from 'react'
import { Search as SearchIcon, ArrowRight } from 'react-bootstrap-icons'
import BrandsProviderFilters from './BrandsProviderFilters'

export default function BrandsSearchBar({ activeProvider, onProviderChange, searchTerm, onSearchChange }) {
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || '')

  // Debounce a kereséshez (1000ms késleltetés, mint az Influencers SearchBar-ban)
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearchChange(localSearchTerm)
    }, 1000)

    return () => clearTimeout(timer)
  }, [localSearchTerm, onSearchChange])

  // Sync external searchTerm changes
  useEffect(() => {
    setLocalSearchTerm(searchTerm || '')
  }, [searchTerm])

  const handleSearch = () => {
    onSearchChange(localSearchTerm)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-b-1 border-border-primary dark:border-rb-dark-mode-lighter mb-6">
      <div className="flex justify-between items-center mt-4 px-44 py-4">
        {/* Bal oldali provider filter gombok */}
        <BrandsProviderFilters activeProvider={activeProvider} onProviderChange={onProviderChange} />

        {/* SearchField - Influencers SearchField stílusával */}
        <div className="flex-grow flex items-center border-1 dark:border-rb-dark-mode-lighter rounded-lg p-1 dark:bg-rb-dark-mode-lighter">
          <div className="rounded-xl p-2 bg-white dark:bg-rb-dark-mode-lighter">
            <SearchIcon className="dark:text-white" />
          </div>
          <input
            className="border-0 p-0 focus:ring-transparent focus:ring-offset-transparent w-full dark:bg-rb-dark-mode-lighter dark:text-white dark:placeholder-gray-400"
            type="text"
            placeholder="Search for brands by name or handle"
            value={localSearchTerm}
            onChange={(e) => setLocalSearchTerm(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button
            className="bg-rb-green rounded-lg p-1 text-white dark:text-rb-dark-mode"
            onClick={handleSearch}
          >
            <ArrowRight className="text-white text-2xl dark:text-rb-dark-mode" />
          </button>
        </div>
      </div>
    </div>
  )
}


